import { render, staticRenderFns } from "./updateName.vue?vue&type=template&id=4ce5d796&scoped=true"
import script from "./updateName.vue?vue&type=script&lang=js"
export * from "./updateName.vue?vue&type=script&lang=js"
import style0 from "./updateName.vue?vue&type=style&index=0&id=4ce5d796&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5d796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce5d796')) {
      api.createRecord('4ce5d796', component.options)
    } else {
      api.reload('4ce5d796', component.options)
    }
    module.hot.accept("./updateName.vue?vue&type=template&id=4ce5d796&scoped=true", function () {
      api.rerender('4ce5d796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/updateName.vue"
export default component.exports